/** 1.3.1 portal strings, stream Q3 (the DMZ split): keys under dmz. if the split needs any text for suppliers. Q3's file. */
export const EXTRAS_Q3_STRINGS = {} as const;
